import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"
import formatStartDate from "@/queries/helpers/formatStartDate"
import { CartUsers } from "@/queries/models"
import queryKeys from "@/queries/queryKeys"

interface UseCartUsersOptions {
  resortExternalId: number
  startDate: Date
}

const useCartUsersQuery = (options: UseCartUsersOptions) => {
  const { resortExternalId, startDate } = options

  const formattedDate = formatStartDate(startDate)

  return useQuery<CartUsers>({
    queryKey: queryKeys.cartUsers(resortExternalId, formattedDate),
    queryFn: async () => {
      const res = await bffApi.get<CartUsers>("/cart-users", {
        params: {
          externalResortId: resortExternalId,
          date: formattedDate,
        },
      })
      return res.data
    },
  })
}

export default useCartUsersQuery
